module.exports = __webpack_public_path__ + "img/cbam-2-en.aad9dea0.png";